import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageChannelService, messageLevel } from '@bndes/bndes-ux4/bndes-angular-utils';

import { LimiteAdicionalService } from '../limite-adicional.service';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { LimiteAdicionalTrancheAgenteFinanceiro } from 'src/app/model/limite-adicional-tranche-agente-financeiro.model';
import { OpcaoFiltro } from 'src/app/model/opcao-filtro.model';

@Component({
  selector: 'app-limite-adicional-por-af',
  templateUrl: './limite-adicional-por-af.component.html',
  styleUrls: ['./limite-adicional-por-af.component.scss'],
  standalone: false,
})
export class LimiteAdicionalPorAfComponent implements OnInit {

  public modo: 'cadastro' | 'edicao' = 'cadastro';
  public ideTranche: number;

  public valorLimiteMascara: string = '';

  public idAgenteFinanceiro: number;
  public idLimiteAdicional: number;
  public valorLimite: number;

  public agentesFinanceiros: OpcaoFiltro[] = [];
  public limitesAdicionaisOpcoes: OpcaoFiltro[] = [];

  public origem: string;

  private registros: LimiteAdicionalTrancheAgenteFinanceiro[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private limiteAdicionalService: LimiteAdicionalService,
    private trancheService: TrancheService,
    private agenteFinanceiroService: AgenteFinanceiroService,
    private messageService: MessageChannelService,
  ) {}

  ngOnInit(): void {
    this.ideTranche = Number(this.route.snapshot.paramMap.get('ideTranche'));
    this.modo = this.router.url.includes('/edicao/') ? 'edicao' : 'cadastro';

    if (this.modo === 'cadastro') {
      this.carregarAgentesFinanceiros();
      this.carregarLimitesAdicionais();
    } else {
      const state = history.state;

      this.origem = state?.origem;

      this.carregarRegistrosEdicao(
        state?.idAgenteFinanceiro,
        state?.idLimiteAdicional
      );
    }
  }

  private carregarAgentesFinanceiros() {
    this.agenteFinanceiroService.getAgentesFinanceiros().subscribe((agentes: AgenteFinanceiro[]) => {
      this.agentesFinanceiros = agentes.map(a => ({ id: a.id, descricao: a.nome }));
    });
  }

  private carregarLimitesAdicionais() {
    this.trancheService.buscarLimitesAdicionaisTranche(this.ideTranche).subscribe((limites: any[]) => {
      this.limitesAdicionaisOpcoes = limites.map(l => ({ id: l['id'], descricao: l['nome'] }));
    });
  }

  private carregarRegistrosEdicao(
    preAgente?: number,
    preLimite?: number
  ) {

    this.limiteAdicionalService
      .buscarTodosComFiltro(this.ideTranche, {})
      .subscribe((res: any) => {

        this.registros = res.resultados || [];

        const mapAgentes = new Map<number, string>();

        this.registros.forEach(r =>
          mapAgentes.set(
            r.idAgenteFinanceiro,
            r.agenteFinanceiro
          )
        );

        this.agentesFinanceiros =
          Array.from(
            mapAgentes,
            ([id, descricao]) => ({ id, descricao })
          );

        
        if (preAgente) {

          this.idAgenteFinanceiro = preAgente;

          this.onAgenteSelecionado();

          if (preLimite) {

            this.idLimiteAdicional = preLimite;

            this.onLimiteSelecionado();
          }
        }
      });
  }

  public onAgenteSelecionado() {
    this.definirValor(null);
    this.valorLimite = null;

    if (this.modo === 'edicao') {
      this.idLimiteAdicional = null;

      const doAgente = this.registros.filter(
        r => r.idAgenteFinanceiro === this.idAgenteFinanceiro
      );

      const mapLimites = new Map<number, string>();
      doAgente.forEach(r => mapLimites.set(r.ideLimiteAdicional, r.limiteAdicional));

      this.limitesAdicionaisOpcoes = Array.from(
        mapLimites,
        ([id, descricao]) => ({ id, descricao })
      );

      if (this.limitesAdicionaisOpcoes.length === 1) {
        this.idLimiteAdicional = this.limitesAdicionaisOpcoes[0].id;
        this.onLimiteSelecionado();
      }
    }
  }

  public onLimiteSelecionado() {
    this.valorLimite = null;

    if (this.modo === 'edicao') {
      const registro = this.registros.find(r =>
        r.idAgenteFinanceiro === this.idAgenteFinanceiro &&
        r.ideLimiteAdicional === this.idLimiteAdicional
      );

      if (registro) {
        this.definirValor(registro.valorLimite);
        this.valorLimite = registro.valorLimite;
      }
    }
  }

  public get exibeLimiteAdicional(): boolean {
    return this.modo === 'cadastro' || !!this.idAgenteFinanceiro;
  }

  public get exibeValorLimite(): boolean {
    return this.modo === 'cadastro' ||
      (!!this.idAgenteFinanceiro && !!this.idLimiteAdicional);
  }

  public get podeSalvar(): boolean {
    return !!this.idAgenteFinanceiro &&
      !!this.idLimiteAdicional &&
      !!this.valorLimite &&
      this.valorLimite > 0;
  }

  public fechar() {

    if (this.origem) {

      this.router.navigate([this.origem]);

    } else {

      this.router.navigate(
        ['limite-adicional/pesquisa'],
        {
          state: {
            voltarComCesta: true,
            cesta: this.ideTranche
          }
        }
      );
    }
  }

  public salvar() {
    if (!this.podeSalvar) {
      return;
    }

    const dto = {
      ideTranche: this.ideTranche,
      idAgenteFinanceiro: this.idAgenteFinanceiro,
      idLimiteAdicional: this.idLimiteAdicional,
      valorLimite: this.valorLimite,
    };

    const req = this.modo === 'cadastro'
      ? this.limiteAdicionalService.cadastrarLimitePorAf(dto)
      : this.limiteAdicionalService.editarLimitePorAf(dto);

    req.subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: this.modo === 'cadastro'
          ? 'Limite por AF cadastrado com sucesso'
          : 'Limite por AF atualizado com sucesso',
      });

      
      this.fechar();
    });
  }

  private definirValor(valor: number | null) {
    this.valorLimite = valor as number;
    this.valorLimiteMascara = (valor === null || valor === undefined)
      ? ''
      : Number(valor).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        });
  }

  public onValorInput(event: any) {
    const digitos = (event.target.value || '').replace(/\D/g, '');

    if (!digitos) {
      this.definirValor(null);
      return;
    }

    this.definirValor(Number(digitos) / 100);
  }
}